// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"2eb5485a","866":"997a1531"}[chunkId] + ".chunk.css";
};